// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__fgHTf"};